import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

import AuthService from '@src/services/AuthService';

import InviteOnboardingCard from '../../components/InviteOnboardingCard';
import { getCompleteRegistrationOrgId } from '../../utils/completeRegistrationPath';

/**
 * Onboarding form for an invitee who signed in without the invite link (Google, password
 * reset, email link). The app guard sends every pending invitee here, with the organization
 * they are pending in as `?org=`, until the backend marks them active. They already have a way
 * to sign in, so no password is asked.
 */
const CompleteRegistration = () => {
  const intl = useIntl();
  const { search } = useLocation();
  const organizationId = getCompleteRegistrationOrgId(search);

  const loadContext = () => new AuthService().getOnboardingContext(organizationId);

  const submit = ({ organizationId: orgId, user }) =>
    new AuthService().completeRegistration({ organizationId: orgId, user });

  return (
    <InviteOnboardingCard
      // Switching organization changes ?org= on the same route; remount to load that invite.
      key={organizationId || 'default'}
      loadContext={loadContext}
      submit={submit}
      skipPassword
      signedIn
      titleId="users.completeRegistration.title"
      intro={intl.formatMessage({ id: 'users.completeRegistration.intro' })}
    />
  );
};

export default CompleteRegistration;
